import { Checkbox } from '@material-ui/core'
import React from 'react'

import { RoomTypeForRateConnection } from '../../types/rateConnection'
import useStyles from './styles/RenderCheckboxRowCell.styles'

interface RenderCheckboxRowCellProps {
  roomTypeIndex: number
  ratePlanIndex: number
  channelIndex: number
  priceClassIndex: number
  cellIndex: number
  updatedRateConnectionList: RoomTypeForRateConnection[]
  setUpdatedRateConnectionList: React.Dispatch<
    React.SetStateAction<RoomTypeForRateConnection[]>
  >
  weekendIndexes: number[]
}

const RenderCheckboxRowCell: React.FC<RenderCheckboxRowCellProps> = ({
  roomTypeIndex,
  ratePlanIndex,
  channelIndex,
  priceClassIndex,
  cellIndex,
  updatedRateConnectionList,
  setUpdatedRateConnectionList,
  weekendIndexes
}) => {
  const classes = useStyles()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUpdatedRateConnectionList([
      ...updatedRateConnectionList.slice(0, roomTypeIndex),
      {
        ...updatedRateConnectionList[roomTypeIndex],
        ratePlans: [
          ...updatedRateConnectionList[roomTypeIndex].ratePlans.slice(
            0,
            ratePlanIndex
          ),
          {
            ...updatedRateConnectionList[roomTypeIndex].ratePlans[
              ratePlanIndex
            ],
            channels: [
              ...updatedRateConnectionList[roomTypeIndex].ratePlans[
                ratePlanIndex
              ].channels.slice(0, channelIndex),
              {
                ...updatedRateConnectionList[roomTypeIndex].ratePlans[
                  ratePlanIndex
                ].channels[channelIndex],
                priceClasses: [
                  ...updatedRateConnectionList[roomTypeIndex].ratePlans[
                    ratePlanIndex
                  ].channels[channelIndex].priceClasses.slice(
                    0,
                    priceClassIndex
                  ),
                  {
                    ...updatedRateConnectionList[roomTypeIndex].ratePlans[
                      ratePlanIndex
                    ].channels[channelIndex].priceClasses[priceClassIndex],
                    dataForEachDate: [
                      ...updatedRateConnectionList[roomTypeIndex].ratePlans[
                        ratePlanIndex
                      ].channels[channelIndex].priceClasses[
                        priceClassIndex
                      ].dataForEachDate.slice(0, cellIndex),
                      {
                        ...updatedRateConnectionList[roomTypeIndex].ratePlans[
                          ratePlanIndex
                        ].channels[channelIndex].priceClasses[priceClassIndex]
                          .dataForEachDate[cellIndex],
                        isConnect: event.target.checked,
                        isChanged:
                          !updatedRateConnectionList[roomTypeIndex].ratePlans[
                            ratePlanIndex
                          ].channels[channelIndex].priceClasses[priceClassIndex]
                            .dataForEachDate[cellIndex].isChanged
                      },
                      ...updatedRateConnectionList[roomTypeIndex].ratePlans[
                        ratePlanIndex
                      ].channels[channelIndex].priceClasses[
                        priceClassIndex
                      ].dataForEachDate.slice(cellIndex + 1)
                    ]
                  },
                  ...updatedRateConnectionList[roomTypeIndex].ratePlans[
                    ratePlanIndex
                  ].channels[channelIndex].priceClasses.slice(
                    priceClassIndex + 1
                  )
                ]
              },
              ...updatedRateConnectionList[roomTypeIndex].ratePlans[
                ratePlanIndex
              ].channels.slice(channelIndex + 1)
            ]
          },
          ...updatedRateConnectionList[roomTypeIndex].ratePlans.slice(
            ratePlanIndex + 1
          )
        ]
      },
      ...updatedRateConnectionList.slice(roomTypeIndex + 1)
    ])
  }

  const isChanged =
    updatedRateConnectionList[roomTypeIndex].ratePlans[ratePlanIndex].channels[
      channelIndex
    ].priceClasses[priceClassIndex].dataForEachDate[cellIndex].isChanged

  return (
    <div
      className={[
        classes.dayContainer,
        weekendIndexes.includes(cellIndex % 7) && classes.weekendDayContainer,
        isChanged && classes.editedDayContainer
      ].join(' ')}>
      <Checkbox
        color="primary"
        checked={
          updatedRateConnectionList[roomTypeIndex].ratePlans[ratePlanIndex]
            .channels[channelIndex].priceClasses[priceClassIndex]
            .dataForEachDate[cellIndex].isConnect
        }
        onChange={(event) => {
          handleChange(event)
        }}
        size="small"
      />
    </div>
  )
}

export default RenderCheckboxRowCell
